<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,5C15,5,12,5,12,5C12,5,12,1,12,1C12,0.45,11.55,0,11,0C11,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,4,16,4,16C4,16,4,12,4,12C4,12,8,12,8,12C8,12,8,16,8,16C8,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,6,16,6C16,5.45,15.55,5,15,5C15,5,15,5,15,5ZM5,10C5,10,2,10,2,10C2,10,2,7,2,7C2,7,5,7,5,7C5,7,5,10,5,10C5,10,5,10,5,10ZM5,5C5,5,2,5,2,5C2,5,2,2,2,2C2,2,5,2,5,2C5,2,5,5,5,5C5,5,5,5,5,5ZM10,10C10,10,7,10,7,10C7,10,7,7,7,7C7,7,10,7,10,7C10,7,10,10,10,10C10,10,10,10,10,10ZM10,5C10,5,7,5,7,5C7,5,7,2,7,2C7,2,10,2,10,2C10,2,10,5,10,5C10,5,10,5,10,5ZM14,14C14,14,12,14,12,14C12,14,12,12,12,12C12,12,14,12,14,12C14,12,14,14,14,14C14,14,14,14,14,14ZM14,10C14,10,12,10,12,10C12,10,12,7,12,7C12,7,14,7,14,7C14,7,14,10,14,10C14,10,14,10,14,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Office',
} as DefineComponent
</script>
